(function (global, factory) {
	typeof exports === 'object' && typeof module !== 'undefined' ? factory(exports, require('reselect')) :
	typeof define === 'function' && define.amd ? define(['exports', 'reselect'], factory) :
	(factory((global['Re-reselect'] = {}),global.Reselect));
}(this, (function (exports,reselect) { 'use strict';

function isStringOrNumber(value) {
  return typeof value === 'string' || typeof value === 'number';
}

var classCallCheck = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

var FlatObjectCache = function () {
  function FlatObjectCache() {
    classCallCheck(this, FlatObjectCache);

    this._cache = {};
  }

  FlatObjectCache.prototype.set = function set$$1(key, selectorFn) {
    this._cache[key] = selectorFn;
  };

  FlatObjectCache.prototype.get = function get$$1(key) {
    return this._cache[key];
  };

  FlatObjectCache.prototype.remove = function remove(key) {
    delete this._cache[key];
  };

  FlatObjectCache.prototype.clear = function clear() {
    this._cache = {};
  };

  FlatObjectCache.prototype.isValidCacheKey = function isValidCacheKey(cacheKey) {
    return isStringOrNumber(cacheKey);
  };

  return FlatObjectCache;
}();

function validateCacheSize(cacheSize) {
  if (cacheSize === undefined) {
    throw new Error('Missing the required property "cacheSize".');
  }
  if (!Number.isInteger(cacheSize) || cacheSize <= 0) {
    throw new Error('The "cacheSize" property must be a positive integer value.');
  }
}

var FifoObjectCache = function () {
  function FifoObjectCache() {
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        cacheSize = _ref.cacheSize;

    classCallCheck(this, FifoObjectCache);

    validateCacheSize(cacheSize);
    this._cache = {};
    this._cacheOrdering = [];
    this._cacheSize = cacheSize;
  }

  FifoObjectCache.prototype.set = function set$$1(key, selectorFn) {
    this._cache[key] = selectorFn;
    this._cacheOrdering.push(key);

    if (this._cacheOrdering.length > this._cacheSize) {
      var earliest = this._cacheOrdering[0];
      this.remove(earliest);
    }
  };

  FifoObjectCache.prototype.get = function get$$1(key) {
    return this._cache[key];
  };

  FifoObjectCache.prototype.remove = function remove(key) {
    var index = this._cacheOrdering.indexOf(key);

    if (index > -1) {
      this._cacheOrdering.splice(index, 1);
    }
    delete this._cache[key];
  };

  FifoObjectCache.prototype.clear = function clear() {
    this._cache = {};
    this._cacheOrdering = [];
  };

  FifoObjectCache.prototype.isValidCacheKey = function isValidCacheKey(cacheKey) {
    return isStringOrNumber(cacheKey);
  };

  return FifoObjectCache;
}();

var LruObjectCache = function () {
  function LruObjectCache() {
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        cacheSize = _ref.cacheSize;

    classCallCheck(this, LruObjectCache);

    validateCacheSize(cacheSize);
    this._cache = {};
    this._cacheOrdering = [];
    this._cacheSize = cacheSize;
  }

  LruObjectCache.prototype.set = function set$$1(key, selectorFn) {
    this._cache[key] = selectorFn;
    this._registerCacheHit(key);

    if (this._cacheOrdering.length > this._cacheSize) {
      var earliest = this._cacheOrdering[0];
      this.remove(earliest);
    }
  };

  LruObjectCache.prototype.get = function get$$1(key) {
    this._registerCacheHit(key);
    return this._cache[key];
  };

  LruObjectCache.prototype.remove = function remove(key) {
    this._deleteCacheHit(key);
    delete this._cache[key];
  };

  LruObjectCache.prototype.clear = function clear() {
    this._cache = {};
    this._cacheOrdering = [];
  };

  LruObjectCache.prototype._registerCacheHit = function _registerCacheHit(key) {
    this._deleteCacheHit(key);
    this._cacheOrdering.push(key);
  };

  LruObjectCache.prototype._deleteCacheHit = function _deleteCacheHit(key) {
    var index = this._cacheOrdering.indexOf(key);
    if (index > -1) {
      this._cacheOrdering.splice(index, 1);
    }
  };

  LruObjectCache.prototype.isValidCacheKey = function isValidCacheKey(cacheKey) {
    return isStringOrNumber(cacheKey);
  };

  return LruObjectCache;
}();

var FlatMapCache = function () {
  function FlatMapCache() {
    classCallCheck(this, FlatMapCache);

    this._cache = new Map();
  }

  FlatMapCache.prototype.set = function set$$1(key, selectorFn) {
    this._cache.set(key, selectorFn);
  };

  FlatMapCache.prototype.get = function get$$1(key) {
    return this._cache.get(key);
  };

  FlatMapCache.prototype.remove = function remove(key) {
    this._cache.delete(key);
  };

  FlatMapCache.prototype.clear = function clear() {
    this._cache.clear();
  };

  return FlatMapCache;
}();

var FifoMapCache = function () {
  function FifoMapCache() {
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        cacheSize = _ref.cacheSize;

    classCallCheck(this, FifoMapCache);

    validateCacheSize(cacheSize);
    this._cache = new Map();
    this._cacheSize = cacheSize;
  }

  FifoMapCache.prototype.set = function set$$1(key, selectorFn) {
    this._cache.set(key, selectorFn);

    if (this._cache.size > this._cacheSize) {
      var earliest = this._cache.keys().next().value;
      this.remove(earliest);
    }
  };

  FifoMapCache.prototype.get = function get$$1(key) {
    return this._cache.get(key);
  };

  FifoMapCache.prototype.remove = function remove(key) {
    this._cache.delete(key);
  };

  FifoMapCache.prototype.clear = function clear() {
    this._cache.clear();
  };

  return FifoMapCache;
}();

var LruMapCache = function () {
  function LruMapCache() {
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        cacheSize = _ref.cacheSize;

    classCallCheck(this, LruMapCache);

    validateCacheSize(cacheSize);
    this._cache = new Map();
    this._cacheSize = cacheSize;
  }

  LruMapCache.prototype.set = function set$$1(key, selectorFn) {
    this._cache.set(key, selectorFn);

    if (this._cache.size > this._cacheSize) {
      var earliest = this._cache.keys().next().value;
      this.remove(earliest);
    }
  };

  LruMapCache.prototype.get = function get$$1(key) {
    var value = this._cache.get(key);

    // Register cache hit
    if (this._cache.has(key)) {
      this.remove(key);
      this._cache.set(key, value);
    }
    return value;
  };

  LruMapCache.prototype.remove = function remove(key) {
    this._cache.delete(key);
  };

  LruMapCache.prototype.clear = function clear() {
    this._cache.clear();
  };

  return LruMapCache;
}();

var defaultCacheCreator = FlatObjectCache;
var defaultCacheKeyValidator = function defaultCacheKeyValidator() {
  return true;
};

function createCachedSelector() {
  for (var _len = arguments.length, funcs = Array(_len), _key = 0; _key < _len; _key++) {
    funcs[_key] = arguments[_key];
  }

  return function (resolver) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    // @NOTE Versions 0.x/1.x accepted "options" as a function
    if (typeof options === 'function') {
      throw new Error('[re-reselect] Second argument "options" must be an object. Please use "options.selectorCreator" to provide a custom selectorCreator.');
    }

    var cache = options.cacheObject || new defaultCacheCreator();
    var selectorCreator = options.selectorCreator || reselect.createSelector;
    var isValidCacheKey = cache.isValidCacheKey || defaultCacheKeyValidator;

    // Application receives this function
    var selector = function selector() {
      var cacheKey = resolver.apply(undefined, arguments);

      if (isValidCacheKey(cacheKey)) {
        var cacheResponse = cache.get(cacheKey);

        if (cacheResponse === undefined) {
          cacheResponse = selectorCreator.apply(undefined, funcs);
          cache.set(cacheKey, cacheResponse);
        }

        return cacheResponse.apply(undefined, arguments);
      }
      console.warn('[re-reselect] Invalid cache key "' + cacheKey + '" has been returned by resolver function.');
      return undefined;
    };

    // Further selector methods
    selector.getMatchingSelector = function () {
      var cacheKey = resolver.apply(undefined, arguments);
      // @NOTE It might update cache hit count in LRU-like caches
      return cache.get(cacheKey);
    };

    selector.removeMatchingSelector = function () {
      var cacheKey = resolver.apply(undefined, arguments);
      cache.remove(cacheKey);
    };

    selector.clearCache = function () {
      cache.clear();
    };

    selector.resultFunc = funcs[funcs.length - 1];

    selector.cache = cache;

    return selector;
  };
}

exports.default = createCachedSelector;
exports.FlatObjectCache = FlatObjectCache;
exports.FlatCacheObject = FlatObjectCache;
exports.FifoObjectCache = FifoObjectCache;
exports.LruObjectCache = LruObjectCache;
exports.FlatMapCache = FlatMapCache;
exports.FifoMapCache = FifoMapCache;
exports.LruMapCache = LruMapCache;
exports.FifoCacheObject = FifoObjectCache;
exports.LruCacheObject = LruMapCache;

Object.defineProperty(exports, '__esModule', { value: true });

})));
//# sourceMappingURL=index.js.map
